module.exports = __webpack_public_path__ + "static/media/SM-LINE.069ec743.svg";